<template>
  <div>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn btn-danger pull-right" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h3 class="modal-title">{{$t('project.select_project')}}</h3>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <!-- Custom Tabs -->
            <div class="nav-tabs-custom">
              <ul class="nav nav-tabs">
                <li class="active">
                  <a href="#tab_all_projects" data-toggle="tab">{{$t('project.all')}}</a>
                </li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane active" id="tab_all_projects">
                  <div class="row">
                    <div class="col-xs-12 table-responsive">
                      <b-table
                        hover
                        :items="project_items"
                        :fields="project_fields"
                        class="mt-3"
                        outlined
                      >
                        <template #head()="scope">
                          <div>{{ $t(scope.label) }}</div>
                        </template>
                        <template
                          #cell(selected)="row"
                        >
                          <i class="fa fa-check" v-if="row.value"></i>
                        </template>
                        <template
                          #cell(project_name)="row"
                        >
                          <a @click="onSelectProject(row.item)">{{row.value}}</a>
                        </template>
                        <!-- <template
                          slot="selected"
                          slot-scope="row"
                        > 
                          <i class="fa fa-check" v-if="row.value"></i>
                        </template>
                        <template
                          slot="project_name"
                          slot-scope="row"
                        >
                          <a @click="onSelectProject(row.item)">{{row.value}}</a>
                        </template> -->
                      </b-table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-default pull-left"
          data-dismiss="modal"
        >{{$t('common.cancel')}}</button>
        <button
          type="button"
          @click="addnew"
          data-dismiss="modal"
          class="btn btn-primary pull-right"
          v-if="GET_ACCOUNT_DATA.id == 1"
        >{{$t('common.addnew')}}</button>
      </div>
    </div>
    <!-- /.modal-content -->
    <!-- Modal dialog -->
    <div class="modal fade" id="modal-SelectProjectConfirm">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">{{ $t("ProjectSelectConfirm.project_select_title") }}</h4>
          </div>
          <div class="modal-body">
            {{ $t("ProjectSelectConfirm.project_select_msg") }}
            {{ projectSelect.name }}
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
            >{{ $t("common.cancel") }}</button>
            <button
              type="button"
              class="btn btn-primary btn-green"
              @click="onSaveSelectProjectConfirm"
            >{{ $t("common.confirm") }}</button>
          </div>
        </div>
      </div>
     </div>
     <!-- End modal dialog -->
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import utils from '@/lib/utils'

export default {
  name: 'ProjectList',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      project_fields: [
        { key: 'selected', label: 'project.selected', sortable: true, class: 'text-center' },
        { key: 'project_name', label: 'project.name', sortable: true },
        { key: 'project_code', label: 'project.code', sortable: true }
      ],
      project_items: [],
      projectSelect: {
        id: null,
        name: ''
      }
    }
  },
  watch: {
    items: function() {
      this.autoSelectProject()
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    ...mapActions([
    ]),
    addnew: function(){
      this.$router.push({
        name: "ProjectAddNew"
      })
    },
    onSelectProject: function(data) {
      // this.$emit("project-select", data.id)
      this.projectSelect.id = data.id
      this.projectSelect.name = data.project_name + '?'
      $("#modal-SelectProjectConfirm").modal("show");
    },
    onSaveSelectProjectConfirm() {
      let data = {
        "project_id" : this.projectSelect.id,
        "is_selected" : true
      }
      sessionStorage.setItem('projectId', this.projectSelect.id)
      this.$emit("project-select", data)
      $("#modal-SelectProjectConfirm").modal("hide");
    },
    initialize: function() {
      this.project_items = this.items
    },
    autoSelectProject: function() {
      let projectId = utils.getProjectSession();
      if (this.projectSelect.id == null && this.items.length === 1 && (projectId === null || projectId !== this.items[0].id)) {
        this.projectSelect.id = this.items[0].id
        this.projectSelect.name = this.items[0].project_name + '?'
        this.onSaveSelectProjectConfirm()
      } else {
        this.initialize()
      }
    }
  },
  mounted() {
    this.initialize()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.check_col {
  width: 50px;
}

.text-center {
  width: 50px;
}

</style>



// WEBPACK FOOTER //
// src/views/Layout/ProjectList.vue